<div class="tree-node-types">
  @if (loaded) {
    <div class="node-types">
      @for (type of nodeTypes; track type) {
        <div
          [attr.data-cy]="type.name"
          class="node-type"
          (click)="typeClicked(type)"
          (keydown.enter)="typeClicked(type)"
          (keydown.space)="typeClicked(type)"
          [class.selected]="type.id === data?.typeSelected$.value?.id"
          tabindex="0"
        >
          <mat-icon svgIcon="{{ type.icon }}" color="primary"></mat-icon>
          <p>{{ type.name }}</p>
        </div>
      }
    </div>
  } @else {
    <app-skeleton></app-skeleton>
  }
</div>
